import { ReviewsTypes } from '@frontend/api-reviews';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

type ReviewAction = 'edit' | 'delete' | 'reply';

type ReviewReplyType = {
  selectedComment?: ReviewsTypes.ReviewComment;
  setSelectedComment: (comment?: ReviewsTypes.ReviewComment) => void;
  pendingComment?: ReviewsTypes.ReviewCommentPayload;
  setPendingComment: (comment?: ReviewsTypes.ReviewCommentPayload) => void;
  isEdit: boolean;
  setIsEdit: (isEdit: boolean) => void;
  reviewAction?: ReviewAction;
  setReviewAction: (reviewAction?: ReviewAction) => void;
};

export const useReviewReplyStore = createStoreWithSubscribe<ReviewReplyType>(
  (set) => ({
    selectedComment: undefined,
    pendingComment: undefined,
    isEdit: false,
    setPendingComment: (comment?: ReviewsTypes.ReviewCommentPayload) => {
      set(
        (state) => {
          state.pendingComment = comment;
        },
        false,
        'SET_REVIEWS_PENDING_COMMENT'
      );
    },
    setSelectedComment: (selectedComment?: ReviewsTypes.ReviewComment) => {
      set(
        (state) => {
          state.selectedComment = selectedComment;
        },
        false,
        'SET_REVIEWS_SELECTED_COMMENT'
      );
    },
    setIsEdit: (isEdit: boolean) => {
      set(
        (state) => {
          state.isEdit = isEdit;
        },
        false,
        'SET_REVIEWS_IS_EDIT'
      );
    },
    reviewAction: undefined,
    setReviewAction: (reviewAction?: ReviewAction) => {
      set(
        (state) => {
          state.reviewAction = reviewAction;
        },
        false,
        'SET_REVIEWS_ACTION'
      );
    },
  }),
  { name: 'ReviewReplyStore', trace: true }
);

export const useReviewReplyShallowStore = createShallowStore(useReviewReplyStore);
